import { post /* get, del, put */ } from '@api/request';

export async function searchRevisionHistory(
  { appraisalService },
  authenticationToken,
  { from = 0, size = 100, query, sort = [] },
) {
  const url = `${appraisalService}/appraisal/revisionhistory`;
  const request = { from, size, query, sort };
  const { body } = await post(authenticationToken, url, request);
  return body;
}

export async function searchRevisionHistoryInternal(
  { appraisalService },
  authenticationToken,
  { page = 0, size = 100, data },
) {
  const url = `${appraisalService}/appraisal/revisionhistory/internal?pageSize=${size}&page=${page}`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}
